import { ErrorResponse, fetchApi } from 'src/shared/lib/response-worker/model'
import { webApiBuildUrl } from '@api/utils'
import { IGuidsConvert, IPrescription, IPrescriptionFull } from '@entities/prescription/contract'

export type PrescriptionNumbers = {
    [key: string]: string
}

export interface IPrescriptionEnterRequest {
    birthday: string
    fullName: string
    prescriptionNumbers: PrescriptionNumbers
    prevPrescriptionGuids?: string[]
}

const prescriptionEnterUrl = 'api/prescription/ValidatePrescription'
const prescriptionCanUseErecipeUrl = 'api/prescription/CanUseErecipe'
const prescriptionGetByPrescriptionGuidsUrl = 'api/prescription/GetPrescriptions'
const prescriptionConvertEmiasGuidsToOurGuids = 'api/prescription/ConvertEmiasGuidsToOurGuids'

export async function prescriptionEnterApi(request: IPrescriptionEnterRequest) {
    const { data } = await fetchApi.post<IPrescriptionFull>(webApiBuildUrl(prescriptionEnterUrl), request)
    if (
        (data as ErrorResponse).IsError &&
        (data as ErrorResponse).TypeDto !== 4 &&
        (data as ErrorResponse).TypeDto !== 5
    )
        throw Error(`error on load prescription id error: ${JSON.stringify(data)}`)
    if ((data as ErrorResponse).IsError && (data as ErrorResponse).TypeDto === 5) {
        return data as ErrorResponse
    }
    if (
        (
            data as unknown as {
                invalidParameters: {
                    name: string
                    text: string
                }[]
            }
        ).invalidParameters
    ) {
        return data as unknown as {
            invalidParameters: {
                name: string
                text: string
            }[]
        }
    }
    return data as IPrescriptionFull
}

export async function prescriptionGetByPrescriptionGuidsApi(prescriptionGuids: string[]) {
    const { data } = await fetchApi.post<IPrescription[]>(
        webApiBuildUrl(prescriptionGetByPrescriptionGuidsUrl),
        prescriptionGuids
    )
    if (data && (data as ErrorResponse).IsError) {
        throw new Error(JSON.stringify(data))
    }
    return data as IPrescription[]
}

export async function prescriptionConvertEmiasGuidsToOurGuidsApi(prescriptionEmiasGuids: string[]) {
    const { data } = await fetchApi.post<IGuidsConvert[]>(
        webApiBuildUrl(prescriptionConvertEmiasGuidsToOurGuids),
        prescriptionEmiasGuids
    )
    return data
}

export function getPrescriptionCanUseErecipeUrl() {
    return webApiBuildUrl(prescriptionCanUseErecipeUrl)
}
